// extracted by mini-css-extract-plugin
module.exports = {"block":"styles-module__block___95Wmp","smiley":"styles-module__smiley___Zu3Kk"};